import React from 'react'
import detectUrlChange from 'detect-url-change';
import { RouterDispatch, RouterUIState } from './model';
import IndexUI from '../../../Index/UI/Browser/Index';
import OrderUI from '../../../Orders/UI/Browser/Order';
import PaymentsUI from '../../../Payments/UI/Browser/Payments';

class Router extends React.Component<{}>{

    componentDidMount() {
        let dispatcher: RouterDispatch = (this.props as any).dispatcher

        detectUrlChange.on('change', (newUrl) => {
            dispatcher.urlChanged()
        });
    }

    render() {
        let state: RouterUIState = (this.props as any).state

        let html: JSX.Element = <div></div>
        if (state.router.mainUI === 'Main') {
            html = <IndexUI />
        } else if (state.router.mainUI === 'PaymentHistory') {
            html = <PaymentsUI />
        } else if (state.router.mainUI === 'OrderHistory') {
            html = <OrderUI />
        }

        return html
    }
}

export default Router
